import React from 'react';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const TrustSafety = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-black to-slate-950 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto">
          {/* Safety Questions Layout */}
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white mb-2">
              Safety <span className="text-cyan-400">Questions</span>
            </h3>
            <p className="text-gray-400">
              EMS + RF technology is not suitable for everyone
            </p>
          </div>

          <div className="glass-card p-8 rounded-xl border border-slate-700">
            <div className="flex items-start space-x-4 mb-6">
              <AlertTriangle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-1" />
              <div>
                <p className="text-gray-300 mb-4">
                  Certain conditions require medical clearance before use including pregnancy, pacemakers, metal implants, and some heart conditions
                </p>
                <p className="text-gray-400 text-sm">
                  Always consult your doctor if you have any concerns
                </p>
              </div>
            </div>

            <a href="/safety" className="block">
              <Button
                variant="outline"
                className="w-full border-cyan-500 text-cyan-400 hover:bg-cyan-500/10"
                data-testid="safety-link-btn"
              >
                See full safety guidelines
                <ExternalLink className="ml-2" size={16} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSafety;
